import React, { lazy } from 'react';
import { Switch } from 'react-router-dom';
import retry from '../../retry';
import PrivateRoute from '../../components/PrivateRoute';
import LinhaPesquisaPage from './LinhaPesquisaPage';
import LinhaPesquisaFormPage from './LinhaPesquisaFormPage';

export default () => (
  <Switch>
    <PrivateRoute
      exact
      path="/linhas-pesquisa"
      title
      permission=""
      component={LinhaPesquisaPage}
    />
    <PrivateRoute
      exact
      path="/linhas-pesquisa/new"
      title
      permission=""
      component={LinhaPesquisaFormPage}
    />
    <PrivateRoute
      exact
      path="/linhas-pesquisa/:id/edit"
      title
      permission=""
      component={LinhaPesquisaFormPage}
    />
  </Switch>
);
